module.exports = __webpack_public_path__ + "img/todo.997cbd43.png";